import { render, staticRenderFns } from "./riderWisePerformanceReport_KSA.vue?vue&type=template&id=7c66666e&"
import script from "./riderWisePerformanceReport_KSA.vue?vue&type=script&lang=js&"
export * from "./riderWisePerformanceReport_KSA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports